import React from 'react';
import { Banner, Layout, Paragraph, ParagraphHeader } from '@axiom/ui';

export type EngagementsViewStateBannerInterestedProps = {
  name?: string;
};

export const EngagementsViewStateBannerInterested: React.FC<
  EngagementsViewStateBannerInterestedProps
> = ({ name = 'ENGAGEMENTS_VIEW_STATE_BANNER_INTERESTED' }) => {
  return (
    <Banner name={name} type="critical" impact="high">
      <Layout direction="vertical" verticalGutter="24px">
        <ParagraphHeader name="INTERESTED_HEADER">
          Next Step: Axiom review
        </ParagraphHeader>
        <Paragraph name="INTERESTED_MESSAGE_1">
          Thanks for expressing interest. We're reviewing profiles now to find
          the strongest match for the Axiom client's needs. If you're selected,
          your submission will move to Active Submissions automatically.
        </Paragraph>
        <Paragraph name="INTERESTED_MESSAGE_2">
          Things can move fast, so we may not always reach out directly. Check
          back here anytime - your latest status will always show in this
          banner.
        </Paragraph>
      </Layout>
    </Banner>
  );
};
